import styled from 'styled-components/macro';
import { easyMove, COLORS, BOX_SHADOW } from 'styleguide';

const Wrapper = styled.div`
  flex-direction: column;
  width: 185px;
  display: flex;
  padding: 13px;
  background-color: ${COLORS.line};
  box-shadow: ${BOX_SHADOW.dropdown};
  border-radius: 4px;
  animation: ${easyMove} 0.25s ease-out;

  label {
    text-align: left;
  }
`;

export default Wrapper;
